import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'src/store';
import { API_VERSION } from 'src/constants/api-routes';
import { setCreationFlow } from 'src/store/slices/creationFlowSlices';
import { getApiVersion } from 'src/utils/apiVersion';

export const CreationFlowWrapper = ({ children }: { children: React.ReactElement }) => {
  const { id } = useParams();
  const location = useLocation();
  const creationFlowState = useAppSelector((s) => s.creationFlowSlices);
  const config = creationFlowState[id];
  const dispatch = useAppDispatch();
  const version = getApiVersion();

  if (config?.step && !config.finished) {
    let step = +config.step;

    if (step === 3 && version === API_VERSION.V2) {
      step = ++step;

      dispatch(setCreationFlow({ id, step, promptType: 'system' }));
    }

    return (
      <Navigate
        to={`/dashboard/projects/${id}/new/${step}${location.search || ''}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};
